import type { MappedFlight } from '../types';

export const getSegmentsData = (flight: MappedFlight) => {
  const startCity = flight.segments[0].dep.city;
  const endCity = flight.segments.slice(-1)[0].arr.city;
  const segmentsAmount = flight.segments.length;

  const getPrevSegmentArr = (index: number) => {
    return index === 0 ? null : flight.segments[index - 1].arr;
  };
  const getNextSegmentDep = (index: number) => {
    if (segmentsAmount - 1 <= index) {
      return null;
    }
    return flight.segments[index + 1].dep;
  };
  const isFlightConnectionVisible = (idx: number) =>
    segmentsAmount > 1 && segmentsAmount - 1 > idx;

  return {
    startCity,
    endCity,
    segmentsAmount,
    getPrevSegmentArr,
    getNextSegmentDep,
    isFlightConnectionVisible,
  };
};
